import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';
import { Chat01RoomType } from '~/types';
import CharacterImage from './CharacterImage/CharacterImage';
import CharacterInfo from './CharacterInfo/CharacterInfo';

export type CharacterCardClickEvent = {
  id: string;
  name?: string;
  desc?: string;
  type: Chat01RoomType;
  image: string;
};

interface CharacterCardProps {
  id: string;
  image: string;
  name: string;
  desc: string;
  create_username: string;
  is_liked: boolean;
  liked_count: number;
  type: Chat01RoomType;
  handleLikeClick: (id: string, isLiked: boolean) => void;
  handleCardClick: ({
    id,
    name,
    desc,
    type,
    image,
  }: CharacterCardClickEvent) => void;
}

export default function CharacterCard({
  id,
  image,
  name,
  desc,
  create_username,
  is_liked,
  liked_count,
  type,
  handleLikeClick,
  handleCardClick,
}: CharacterCardProps) {
  return (
    <>
      <Container
        onClick={() => handleCardClick({ id, name, desc, type, image })}
      >
        <div
          css={css`
            padding: 4px;
          `}
        >
          <CharacterImage
            id={id}
            image={image}
            create_username={create_username}
            is_liked={is_liked}
            handleLikeClick={handleLikeClick}
          />
        </div>
        <div
          css={css`
            padding: 0 8px 8px 8px;
          `}
        >
          <CharacterInfo name={name} desc={desc} liked_count={liked_count} />
        </div>
      </Container>
    </>
  );
}

const Container = styled(FlexStack)`
  ${({ theme }) => css`
    border-radius: 18px;
    background: ${theme.backgroundColor.bg_dark_2};
    gap: 4px;
  `}
`;
